import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICE_PROVIDER_ID_LOADING = 'GET_INVOICE_PROVIDER_ID_LOADING';
export const GET_INVOICE_PROVIDER_ID_SUCCESS = 'GET_INVOICE_PROVIDER_ID_SUCCESS';
export const GET_INVOICE_PROVIDER_ID_REJECT = 'GET_INVOICE_PROVIDER_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceProviderIdLoading = () => ({ type: GET_INVOICE_PROVIDER_ID_LOADING });
export const getInvoiceProviderIdSuccess = (payload) => ({ type: GET_INVOICE_PROVIDER_ID_SUCCESS, payload });
export const getInvoiceProviderIdReject = (payload) => ({ type: GET_INVOICE_PROVIDER_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getInvoiceProviderIdRequest = async ({ id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { ProvidersTranckingId: id },
    }, getState);
    return request(`/ProvidersBillingTracking/web/GetProvidersBillingTrackingById`, options);
};